// extracted by mini-css-extract-plugin
export var body = "_39-1";
export var bodyPadded = "_39-2";
export var chevron = "_39-4";
export var chevronOpen = "_39-5";
export var header = "_39-0";
export var icon = "_39-3";